import React from 'react';

export const Notfound = () => <h1>Not found</h1>;
